import {StyleSheet, Platform} from 'react-native';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      padding: 16,
      flexDirection: 'row',
      alignItems: Platform.OS === 'web' ? 'flex-start' : 'center',
      borderRadius: 16,
      backgroundColor: colors.surface,
      shadowColor: colors.shadow,
      shadowOffset: {
        width: 0,
        height: 30,
      },
      shadowOpacity: 0.2,
      shadowRadius: 30,
      elevation: 5,
      maxWidth: Platform.OS === 'web' ? 400 : undefined,
    },
    fullFlex: {
      flex: 1,
    },
  });

export default makeStyles;
